export default "__VITE_ASSET__B5WHW6$y__"